import React from 'react'

import { ReactComponent as CloseIcon } from '../../../../static/images/close.svg'

import './styles.scss'

type Props = {
  isOpen: boolean
  onClose: () => void
  header: React.ReactNode
  panelId?: string
  panelAriaLabel?: string
  children: React.ReactNode
  footer?: React.ReactNode
  bodyRef?: React.RefObject<HTMLDivElement>
}

const PageRightRailColumn: React.FC<Props> = ({
  isOpen,
  onClose,
  header,
  panelId,
  panelAriaLabel,
  children,
  footer,
  bodyRef,
}) => (
  <aside
    className={[
      'page-right-rail-layout__rail',
      isOpen ? 'page-right-rail-layout__rail--open' : '',
    ].filter(Boolean).join(' ')}
    aria-label={panelAriaLabel}
  >
    <div
      id={panelId}
      className={[
        'page-right-rail-layout__rail-container',
        isOpen ? 'page-right-rail-layout__rail-container--open' : '',
      ].filter(Boolean).join(' ')}
    >
      {isOpen ? (
        <>
          <div className='page-right-rail-panel__header'>
            <div className='page-right-rail-panel__header-title'>{header}</div>
            <button
              type='button'
              className='page-right-rail-panel__close'
              onClick={onClose}
              aria-label='Close panel'
            >
              <CloseIcon width={25} height={25} />
            </button>
          </div>
          <div className='page-right-rail-panel__body' ref={bodyRef}>
            {children}
          </div>
          {footer ? <div className='page-right-rail-panel__footer'>{footer}</div> : null}
        </>
      ) : (
        <div className='page-right-rail-panel__collapsed'>{header}</div>
      )}
    </div>
  </aside>
)

export default PageRightRailColumn
